export interface SelectProps {
  options: string[]
  value: string
  ariaLabel: string
  onChange: (value: string) => void
  noDefaultValue?: boolean
}

export const SELECT_ELEMENTS = {
  SELECT: 'select-select',
  VALUE: 'select-value',
  OPTION: 'select-option',
  OPTIONS: 'select-options',
}
